(function(){
  'use strict';

  angular.module('clientDashboardApp').directive('pageTracking', pageTracking);

  PageTrackingController.$inject = ['$rootScope','$location','pageTrackingService','updateService', 'adminPageInfo', 'adminSearchService', 'pagingService'];

  function PageTrackingController($rootScope, $location, pageTrackingService, updateService, adminPageInfo, adminSearchService, pagingService){

    pageTrackingService.updateCurrentUrl($location.path());

    $rootScope.$on('$stateChangeSuccess',function() {
      pageTrackingService.updateCurrentUrl($location.path());
    });

    $rootScope.$on('$stateChangeStart',function(event,toState,toParams, fromState, fromParams){

      if(toState.resolve && toState.resolve.pageInfo){
        adminPageInfo.setCurrentPageInfo(toState.resolve.pageInfo);
      }

      if(adminPageInfo.pageTypeChange() || !pageTrackingService.pageUsesUpdates()){
        updateService.resetUpdateStatus();
        adminSearchService.resetQuery();
        pagingService.resetPagingState();
      }
    })

  }

  function pageTracking() {
    return {
      restrict: 'A',
      scope: {},
      controller: PageTrackingController
    }
  }

})();


